var _Path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import Svg, { Path } from "react-native-svg";

function SvgPushbells(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    width: 148,
    height: 62,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    d: "M147.232 50.518l-14.136-48.34h-20.661v12.933H36.1V2.178H16.744L1.303 50.518c-1.523 5.3 2.61 10.6 8.264 10.6h129.618c5.437 0 9.569-5.3 8.047-10.6zm-31.752-6.573H32.837c-2.175 0-3.914-2.12-3.044-4.24l6.524-24.382h76.336l5.872 24.594c.87 1.908-.653 4.028-3.045 4.028z",
    fill: "#D9D9D9"
  })), /*#__PURE__*/React.createElement(Path, {
    d: "M108.677-3.612h-69.03a6.01 6.01 0 00-6.01 6.01v10.53a6.01 6.01 0 006.01 6.01h69.03a6.01 6.01 0 006.01-6.01V2.398a6.01 6.01 0 00-6.01-6.01z",
    fill: "#D9D9D9",
    stroke: props.fill,
    strokeWidth: 5
  }));
}

export default SvgPushbells;